document.addEventListener("DOMContentLoaded", () => {
  const stickyElements = [...document.querySelectorAll('.shopify-section-group-header-group')].filter(el => getComputedStyle(el).position === 'sticky');

  stickyElements.forEach((el) => {
    const originalIndex = Array.from(stickyElements).indexOf(el);

    let totalHeight = 0;

    for (let i = 0; i < originalIndex; i++) {
      totalHeight += stickyElements[i].offsetHeight;
    }

    el.style.top = `${totalHeight}px`;
  });
});